const initThemeMain = () => {
  if (!window.gsap || !window.ScrollTrigger) {
    return;
  }

  window.gsap.registerPlugin(window.ScrollTrigger);


  const titleItems = document.querySelectorAll('.hero-minds__title>*, .hero-minds__scroll');
  titleItems.forEach((item, index) => {
    let delay = .4 + (index * 0.2);
    window.gsap.fromTo(
      item,
      {
        opacity: 0,
        y: 62,
      },
      {
        opacity: 1,
        y: 0,
        duration: 1.2,
        ease: 'power2.out',
        delay: delay,
      }
    );
  });

  // const headerItems = document.querySelectorAll('.header > *:not(.section--menu)');
  // headerItems.forEach((item, index) => {
  //   let delay = .2
  //   window.gsap.fromTo(
  //     item,
  //     {
  //       opacity: 0,
  //       y: 31,
  //     },
  //     {
  //       opacity: 1,
  //       y: 0,
  //       duration: 1.2,
  //       ease: 'power2.out',
  //       delay: delay,
  //       onComplete: () => {
  //         document.querySelector('.cart__show').style.transition = '.3s all ease'
  //       }
  //     }
  //   );
  // });

  const getNextSection = (section) => {
    let nextSection = section.parentElement.nextElementSibling;

    while (nextSection && !nextSection.classList.contains('shopify-section')) {
      nextSection = nextSection.nextElementSibling;
    }

    return nextSection;
  };

  document.querySelectorAll('.section--hero-minds').forEach((heroSection) => {
    const nextSection = getNextSection(heroSection);

    if (!nextSection) {
      return;
    }

    window.ScrollTrigger.create({
      trigger: heroSection,
      start: 'top top',
      endTrigger: nextSection,
      end: 'top top',
      pin: true,
      pinSpacing: false,
      anticipatePin: 0,
    });
  });

  let blurElements = document.querySelectorAll('.intro__title > *');
  blurElements.forEach((element) => {
    window.gsap.fromTo(
      element,
      {
        filter: 'blur(10px)',
      },
      {
        filter: 'blur(0px)',
        ease: 'power2.out',
        scrollTrigger: {
          trigger: element,
          start: 'top 70%',
          end: () => `+=${window.innerHeight / 3}`,
          ease: 'power2.out',
          scrub: true,
          invalidateOnRefresh: true,
        },
      }
    );
  });

  document.querySelectorAll('.js-reveal').forEach((item) => {
    window.gsap.set(item, {
      opacity: 0,
      y: window.isMobile ? 30 : 70,
    });
    window.gsap.to(item, {
      opacity: 1,
      y: 0,
      duration: window.isTablet ? 1 : 2,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: item,
        start: window.isTablet ? 'top 90%' : 'top 100%', 
      },
    });
  });



  document.querySelectorAll('.team-intro__imgs').forEach((imagesWrap) => {
    const absoluteImages = Array.from(imagesWrap.querySelectorAll('.team-intro__img'));

    if (!absoluteImages.length) {
      return;
    }

    const totalDuration = absoluteImages.length;

    const timeline = window.gsap.timeline({
      scrollTrigger: {
        trigger: imagesWrap,
        start: 'top bottom',
        end: () => `+=${absoluteImages.length * window.innerHeight / (window.isMobile ? 3 : 2)}`,
        scrub: 1,
        invalidateOnRefresh: true,
      },
    });

    absoluteImages.forEach((image, index) => {
      window.gsap.set(image, {
        y: index === 0 ? 0 : '110%',
        transformOrigin: 'center bottom',
        scale: 1.2,
      });

      timeline.to(
        image,
        {
          scale: 1,
          duration: totalDuration,
          ease: 'none',
        },
        0
      );

      timeline.to(
        image,
        {
          y: 0,
          duration: 1,
          ease: 'none',
        },
        index
      );
    });
  });

  ScrollTrigger.matchMedia({
    "(min-width: 1025px)": () => {
      document.querySelectorAll('.team-intro').forEach((section) => {
        const title = section.querySelector('.team-intro__title');
        const image = section.querySelector('img');

        if (!title) {
          return;
        }

        window.gsap.fromTo(
          title,
          {
            y: 50,
          },
          {
            // y: () => 300 * 250 / title.offsetHeight * window.innerWidth / 1720,
            y: () => image.offsetHeight - title.offsetHeight * .9,
            ease: 'none',
            scrollTrigger: {
              trigger: section,
              start: 'top bottom',
              end: () => `+=${window.innerHeight}`,
              scrub: true,
              invalidateOnRefresh: true,
            },
          }
        );
      });
    }
  });

  // ScrollTrigger.matchMedia({
  //   "(max-width: 1024px)": () => {
  //     document.querySelectorAll('.section--team-intro').forEach((section) => {
  //       let content = section.querySelector('.team-intro__content');
  //       window.gsap.fromTo(
  //         content,
  //         {
  //           y: 200,
  //         },
  //         {
  //           y: 0,
  //           ease: 'none',
  //           scrollTrigger: {
  //             trigger: section,
  //             start: 'top bottom',
  //             end: '+=1000',
  //             scrub: true,
  //             markers: true,
  //             invalidateOnRefresh: true,
  //           },
  //         }
  //       );
  //     });
  //   }
  // });
  

  document.querySelectorAll('.team-intro__title').forEach((title) => {
    window.gsap.fromTo(
      title,
      {
        filter: 'blur(10px)',
      },
      {
        filter: 'blur(0px)',
        ease: 'power2.out',
        scrollTrigger: {
          trigger: title.parentElement,
          start: window.isTablet ? 'top 90%' : 'top center',
          end: '+=300',
          ease: 'power2.out',
          scrub: true,
        },
      }
    );
  });

  document.querySelectorAll('.product-card__video').forEach((element) => {
    const video = element.querySelector('video');
    const button = element.querySelector('.product-card__video-play');

    if (!video || !button) {
      return;
    }

    const syncVideoButtonState = () => {
      const isPlaying = !video.paused && !video.ended;
      button.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
      button.setAttribute('aria-pressed', String(isPlaying));
      button.classList.toggle('is-paused', !isPlaying);
    };

    button.addEventListener('click', (event) => {
      event.preventDefault();

      if (!video.paused && !video.ended) {
        video.pause();
        return;
      }

      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    });

    video.addEventListener('play', syncVideoButtonState);
    video.addEventListener('pause', syncVideoButtonState);
    video.addEventListener('ended', syncVideoButtonState);

    syncVideoButtonState();
  });

  document.querySelectorAll('.products-cards__wrap').forEach((element) => {
    new Swiper(element, {
      slidesPerView: 'auto',
      slidesOffsetBefore: 12,
      slidesOffsetAfter: 12,
      spaceBetween: 4,
      navigation: {
        prevEl: element.querySelector('.slider__arrow--left'),
        nextEl: element.querySelector('.slider__arrow--right'),
      },
      pagination: {
        el: element.querySelector('.slider-product__circles'),
        clickable: true,
        bulletClass: 'slider-product__circle',
        bulletActiveClass: 'active',
      },
      breakpoints: {
        768: {
          spaceBetween: 6,
          slidesOffsetAfter: 12,
        }
      }
    });
  });

  document.querySelectorAll('.other-products__wrap').forEach((element) => {
    const arrows = element.querySelectorAll('.slider__arrow');

    new Swiper(element, {
      slidesPerView: 2.5,
      spaceBetween: 4,
      navigation: {
        prevEl: arrows[0],
        nextEl: arrows[1],
      },
      slidesOffsetBefore: 10,
      slidesOffsetAfter: 10,
      pagination: {
        el: element.querySelector('.slider-product__circles'),
        clickable: true,
        bulletClass: 'slider-product__circle',
        bulletActiveClass: 'active',
      },
      breakpoints: {
        1400: {
          slidesPerView: 5.5,
        },
        1200: {
          slidesPerView: 4.5,
        },
        992: {
          slidesPerView: 4.5,
        },
        768: {
          slidesPerView: 3.5,
          slidesOffsetBefore: 12,
          slidesOffsetAfter: 12,
          spaceBetween: 12,
        },
        550: {
          slidesPerView: 2.5,
        }
      }
    });
  });

  new Swiper('.media-blocks__wrap', {
    slidesPerView: 'auto',
    slidesOffsetBefore: 12,
    slidesOffsetAfter: 12,
    spaceBetween: 4,
    navigation: {
      prevEl: '.media-blocks__wrap .slider__arrow--left',
      nextEl: '.media-blocks__wrap .slider__arrow--right',
    },
    slidesOffsetBefore: 12,
    slidesOffsetAfter: 12,
    pagination: {
      el: document.querySelector('.media-blocks__wrap  .slider-product__circles'),
      clickable: true,
      bulletClass: 'slider-product__circle',
      bulletActiveClass: 'active',
    },
    breakpoints: {
      768: {
        slidesPerView: 1.5,
        spaceBetween: 6,
        slidesOffsetBefore: 12,
        slidesOffsetAfter: 24,
      },
    }
  });
  let journalSwiper = null;

  function initJournalSwiper() {
    if (window.innerWidth <= 1280 && journalSwiper === null) {
      journalSwiper = new Swiper('.journal-list', {
        slidesPerView: 1.3,
        slidesOffsetBefore: 12,
        slidesOffsetAfter: 12,
        spaceBetween: 4,
        navigation: {
          prevEl: '.journal-list .slider__arrow--left',
          nextEl: '.journal-list .slider__arrow--right',
        },
        pagination: {
          el: document.querySelector('.media-blocks__wrap  .slider-product__circles'),
          clickable: true,
          bulletClass: 'slider-product__circle',
          bulletActiveClass: 'active',
        },
      });
    } else if (window.innerWidth > 1280 && journalSwiper !== null) {
      journalSwiper.destroy(true, true);
      journalSwiper = null;
    }
  }

  initJournalSwiper();
  window.addEventListener('resize', initJournalSwiper);

  

};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initThemeMain, { once: true });
} else {
  initThemeMain();
}
